import { HTTP_TYPES } from '@/lib/enums';
import api from '@/api/api';

const API_VERSION = 'v2';

const response = {
	/**
	 * Every company as a CSV download, `id` and `name`, ordered by name.
	 *
	 * `includeSiteCount` appends a `site_count` column, resolved server-side in
	 * the same query. Absence is what the endpoint reads as false, so the flag is
	 * omitted entirely rather than sent as `false`: `api()` appends a query string
	 * for any truthy `params`, so an object here would always show up on the URL.
	 */
	async getCompaniesCSV(includeSiteCount: boolean = false): Promise<any> {
		return await api(
			HTTP_TYPES.GET,
			`${import.meta.env.VITE_DEPOT_API_COMPANIES}/companies/csv`,
			undefined,
			includeSiteCount ? { include_site_count: 'true' } : undefined,
			'application/json',
			API_VERSION,
		);
	},
	async getCompaniesSubscriptions(): Promise<any> {
		return await api(
			HTTP_TYPES.POST,
			`${import.meta.env.VITE_DEPOT_API_COMPANIES}/companies/subscriptions`,
			undefined,
			undefined,
			'application/json',
			API_VERSION,
		);
	},
	async postGetCompanies(payload: any): Promise<any> {
		// page: string,
		// page_size: string,
		// tokens: { returnedTokens }

		return await api(
			HTTP_TYPES.POST,
			`${import.meta.env.VITE_DEPOT_API_COMPANIES}/companies`,
			payload,
			undefined,
			'application/json',
			API_VERSION,
		);
	},
	async postExportCompanies(payload: any): Promise<any> {
		return await api(
			HTTP_TYPES.POST,
			`${import.meta.env.VITE_DEPOT_API_COMPANIES}/companies`,
			payload,
			undefined,
			'application/json',
			API_VERSION,
			{
				Accept: 'text/csv',
			},
		);
	},
	async getAllCompanies(): Promise<any> {
		return await api(
			HTTP_TYPES.GET,
			`${import.meta.env.VITE_DEPOT_API_COMPANIES}/companies/all`,
			undefined,
			undefined,
			'application/json',
			API_VERSION,
		);
	},
	async getTotalCompaniesCount(): Promise<any> {
		return await api(
			HTTP_TYPES.GET,
			`${import.meta.env.VITE_DEPOT_API_COMPANIES}/companies/count`,
			undefined,
			undefined,
			'application/json',
			API_VERSION,
		);
	},
	async postCreateCompaniesWithCSV(payload: any): Promise<any> {
		// csv: file

		return await api(
			HTTP_TYPES.POST,
			`${import.meta.env.VITE_DEPOT_API_COMPANIES}/companies/upload`,
			payload,
			undefined,
			'application/json',
			API_VERSION,
		);
	},
	/**
	 * Run the site-deduplication process from an uploaded CSV. Sends the file as
	 * multipart/form-data and streams progress via `onChunk`.
	 * POST /company/companies/dedupe-sites
	 */
	async dedupeSites(
		formData: FormData,
		onChunk: (chunk: string) => void,
		signal?: AbortSignal,
	): Promise<void> {
		await api(
			HTTP_TYPES.POST,
			`${import.meta.env.VITE_DEPOT_API_COMPANIES}/companies/dedupe-sites`,
			formData,
			undefined,
			'application/json',
			API_VERSION,
			{},
			onChunk,
			signal,
		);
	},
};

export default response;
